// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__adKUG","content":"Layout_content__FqjNh"};